/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductTileMeasurements_item = {
    readonly measurement: {
        readonly display: ReadonlyArray<{
            readonly unit: string | null;
            readonly value: string | null;
        } | null> | null;
        readonly size: {
            readonly value: string | null;
        } | null;
    } | null;
    readonly " $refType": "ProductTileMeasurements_item";
};
export type ProductTileMeasurements_item$data = ProductTileMeasurements_item;
export type ProductTileMeasurements_item$key = {
    readonly " $data"?: ProductTileMeasurements_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductTileMeasurements_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ProductTileMeasurements_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "measurement",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "display",
          "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
          "args": [
            {
              "kind": "Literal",
              "name": "addLabel",
              "value": true
            },
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "height",
                "width",
                "depth",
                "diameter"
              ]
            },
            {
              "kind": "Literal",
              "name": "separator",
              "value": " "
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "unit",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "size",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSize",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f33f016bf42f65d1cb0437eb3b368b37';
export default node;
